import React from 'react';
import ISVGIcon from './interfaces/ISVGIcon';

const ZoomToFit = ({ fill }: ISVGIcon): React.ReactElement => (
    <svg viewBox="0 0 16 16">
        <path
            fill={fill}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.6 0H0V1.6V6.4H1.6V1.6H6.4V0H1.6ZM0 9.6V14.4V16H1.6H6.4V14.4H1.6V9.6H0ZM16 6.4V1.6V0H14.4H9.6V1.6H14.4V6.4H16ZM16 9.6V14.4V16H14.4H9.6V14.4H14.4V9.6H16Z"
        />
    </svg>
);

export default ZoomToFit;
